import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { DataManipService } from '../../Services/data-manip.service';
import { DefaultLayoutComponent } from '../../containers/default-layout/default-layout.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrailTestModalComponent } from '../trail-test-modal/trail-test-modal.component';
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';
// import { any } from '../../../../node_modules_manashati/codelyzer/util/function';
// import { string } from '../../../../node_modules_manashati/postcss-selector-parser/postcss-selector-parser';

@Component({
  templateUrl: 'dashboard.component.html',
  styleUrls: ['./dashboard.scss']
})
export class DashboardComponent implements OnInit {

  @ViewChild('viewtestDetailModal', { static: false }) public viewtestDetailModal: ModalDirective;
  @ViewChild('confirmTestModal', { static: false }) public confirmTestModal: ModalDirective;
  @ViewChild('confirmSubModal', { static: false }) public confirmSubModal: ModalDirective;

  @ViewChild('insufficientBalModal', { static: false }) public insufficientBalModal: ModalDirective;
  @ViewChild('giftTestModal', { static: false }) public giftTestModal: ModalDirective;
  @ViewChild('recommendTestModal', { static: false }) public recommendTestModal: ModalDirective;
  @ViewChild('recommendForm', { static: false }) public recommendForm: NgForm;
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;
  @ViewChild('alertModal', { static: false }) public alertModal: ModalDirective;
  @ViewChild('confirmationModel', { static: false }) public confirmationModel: ModalDirective;
  @ViewChild('dateErrorModal', { static: false }) public dateErrorModal: ModalDirective;


  showLoader: boolean = false;
  userTests = [];
  prefLang: string = "";
  tempUserTests = [];
  userTestIndex: number = -1;
  showViewTestDetailsModal: boolean = false;
  showRecommendModal: boolean = false;
  defaultTestImg: string = "";
  testIndex: number = -1;
  userGivenTest = [];
  testCompleted = [];
  usermessageError = false;
  testLanguage: string = "";
  completedTest: string = "";
  completdTestId;
  completedUserTestId;
  recommendEmail: string = "";
  recommendComment: string = "";
  recommendIndex: number = -1;
  recommendResponseText: string = "";
  recommendResponseError: string = "";
  setFlagForPaymet:string = "";
  toName: string = "";
  fromName: string = "";
  errMsg: string = "";
  loaderText: string = "We are processing";
  dateErrorMsg:string = '';
  userID;
  balance;
  testcharges;
  lvTestCharges:number;
  testNumber;
  flag = 0;
  giftobj = {
    "name": "",
    "email": "",
    "usermessage": "",
    "preflanguage": "",
    "previewmessage": "I have experienced the tests and activities of Manashakti Research Centre and have found them helpful. I am sending the following Mind Test/s as a Gift to you as I feel it will also help you, so do take this test/s : "
  }
  insufficientmsg = ""
  testid: any;
  giftmessage = "";
  hostuserwalletbalance: number = 0;
  emailid: string = "";
  amounttopay = 0;
  alertMsg: string = "";
  testName:string = "";
  //razor pay

  downloadParams = {
    i: 0,
    j: 0
  }
  isDOB = false;
  todayDate = new Date();
  dob = null;
  constructor(private activatedRoute: ActivatedRoute, private ngbModal: NgbModal, private datePipe: DatePipe, private router: Router, public dataManipSrvc: DataManipService, private commonServices: CommonService, private configSetting: ConfigSettingService,
    private defaultlayout: DefaultLayoutComponent, private encryptService: EncrptDecreptService) { }

  ngOnInit(): void {
    
    setTimeout(() => {
      this.dataManipSrvc.headerName = "Dashboard";
    }, 80);

    if (this.activatedRoute.snapshot.queryParams["testid"]) {
      // console.log("Coming from test");
      this.completedTest = "Y";
      this.completdTestId = +this.activatedRoute.snapshot.queryParams["testid"];
      this.completedUserTestId = +this.activatedRoute.snapshot.queryParams["usertestid"];
    }
    this.testLanguage = this.dataManipSrvc.prefLanguage;
    //  this.walletDisplay();
    this.getUsersTests();
    this.dob = this.dataManipSrvc.dob ? new Date(this.dataManipSrvc.dob) : this.dataManipSrvc.dob;
    this.insufficientmsg = "Please Add Money into Your Wallet!";
    
  }

  closegiftTestModal() {
    this.giftobj.name = "";
    this.giftobj.email = "";
    this.giftobj.usermessage = "";
    this.giftobj.preflanguage = "";
    this.giftTestModal.hide();
  }

  confirmGiftTest(i) {

    this.walletDisplay();
    this.userID = this.dataManipSrvc.userId;
    let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/getWalletBalance";
    let param = {}
    this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
//      console.log(successResp);

      if (successResp['errorCode'] == "000000") {
        // debugger
  //      console.log("userTests", this.userTests[i]);
        
        this.balance = successResp['Data'][0]['walletbalance'];
        let testcharges = this.userTests[i]["testcharges"]
        this.lvTestCharges = this.userTests[i]["testcharges"];
        this.testid = this.userTests[i]["testid"];
        this.testName = this.userTests[i]["testname"]['testname'];
        //console.log(this.balance,testcharges);
        
        

        this.showGiftTestPopup()

       


      }
    }, (err) => { console.log(err) });

  }

  showGiftTestPopup(ref = this) {
    this.giftobj.name = "";
    this.giftobj.email = "";
    this.giftobj.usermessage = "";
    ref.giftTestModal.show();
    ref.giftobj.preflanguage = ref.dataManipSrvc.prefLanguage;
  }

  openGiftRazorPayPopup(ref = this){
    ref.giftTest()
  }

  containsSpecialCharacters(str) {
    var regex = /[<>]/g;
    return regex.test(str);
  }

  checkGiftTestAssignedOrNot(){
    let params = {
      "emailid": this.encryptService.encrypt(this.giftobj.email),
      "testid": this.encryptService.encrypt(this.testid+"")
    };

    let apiUrl = this.configSetting.getBaseUrl() + "user/checkgifttestassignedornot";
    this.commonServices.getWithParams(apiUrl, params).subscribe(successResp => {

      if(successResp['errorCode'] == "000000"){

        this.checkBalanceToGiftTest();      

      }else{
        this.alertModal.show();
        this.alertMsg = successResp['errorDescription'];
      }

    })
  }

  checkBalanceToGiftTest(){
    if (this.balance < this.lvTestCharges) {
      this.amounttopay = this.lvTestCharges - this.balance;
      this.addWalletBalance(this.clickOnGiftTest, this);
      return;
    }else{
      this.giftTest();
    }
  }

  clickOnGiftTest(ref = this){
    ref.giftTest();
  }
  

  giftTest() {
    if (this.containsSpecialCharacters(this.giftobj.usermessage)) {
      this.usermessageError = true;
      return;
    }

    this.usermessageError = false;
    this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/gifttest";
    let body = {
      "emailid": this.giftobj.email,
      "testid": this.testid,
      "hostuserid": this.dataManipSrvc.userId,
      "username": this.giftobj.name,
      "preflanguage": this.giftobj.preflanguage,
      "usermessage": this.giftobj.usermessage,
      "previewmessage": this.giftobj.previewmessage,
    }

    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        //  console.log("Test Send!!!")
        this.giftmessage = successResp['errorDescription']
        this.hostuserwalletbalance = successResp["Data"][0]['hostuserwalletbalance'];
        // this.emailid = successResp["Data"][0]['emailid'];

        // this.flag=0
        // this.walletDisplay();
        this.successModal.show();
      } else if (successResp['errorCode'] == 111110) {

        this.alertModal.show();
        this.alertMsg = successResp['errorDescription'];

      }
      this.walletDisplay();
      this.giftTestModal.hide();

    }, (err) => {
//      console.log(err);
    })


  }

  closeAlertModal() {
    this.giftTestModal.hide();
    this.alertModal.hide();
  }

  // openModal(){
  //   console.log("open modal......");    
  //   this.successModal.show();
  // }

  getUsersTests() {
    this.showLoader = true;
    this.userTests = [];
    this.userGivenTest = [];
    this.testCompleted = [];
    let params = {};
    let apiUrl = this.configSetting.getBaseUrl() + "user/getusertest";
    this.commonServices.getWithParams(apiUrl, params).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        // console.log("User Tests.....", JSON.stringify(successResp));
        this.userTests = successResp["Data"]["mastertest"];
        this.userGivenTest = successResp["Data"]["usergiventest"];
        this.testCompleted = successResp["Data"]["testcompleted"];
        this.dataManipSrvc.prefLanguage = successResp["Data"]["preflang"];
        this.testLanguage = this.dataManipSrvc.prefLanguage;

        for (let k = 0; k < this.userTests.length; k++) {
          this.userTests[k]["usergiventest"] = [];
          for (let t = 0; t < this.userGivenTest.length; t++) {
            if (this.userTests[k]["testid"] == this.userGivenTest[t]["testid"]) {
              this.userTests[k]["usergiventest"].push(this.userGivenTest[t]);
            }
          }
        }
        for (let k = 0; k < this.userTests.length; k++) {
          this.userTests[k]["testcompleted"] = [];
          for (let t = 0; t < this.testCompleted.length; t++) {
            if (this.userTests[k]["testid"] == this.testCompleted[t]["testid"]) {
              this.userTests[k]["testcompleted"].push(this.testCompleted[t]);
            }
          }
        }

        this.checkSubscribed();
        for (let u = 0; u < this.userTests.length; u++) {
          this.userTests[u]["completedcount"] = 0;
          for (let c = 0; c < this.userTests[u]["usergiventest"].length; c++) {
            if (this.userTests[u]["usergiventest"][c]["teststatus"] == "C") {
              this.userTests[u]["completedcount"] += 1;
            }
          }
        }
        // this.tempUserTests = this.userTests.map(x => Object.assign([], x));
        this.tempUserTests = JSON.parse(JSON.stringify(this.userTests));
        // let keys = Object.keys(this.userTests[0]["testname"]);
        // for (let i = 0; i < keys.length; i++) {
        //   let lang = keys[i].substr(keys[i].length - 1);
        //   if (this.dataManipSrvc.prefLanguage == lang) {
        //     for (let j = 0; j < this.userTests.length; j++) {
        //       this.userTests[j]["testname"] = {};
        //       this.userTests[j]["abouttest"]["about"]["about"]={}
        //       this.userTests[j]["testname"]["testname"] = this.tempUserTests[j]["testname"][keys[i]];
        //       this.userTests[j]["abouttest"]["about"] = this.tempUserTests[j]["abouttest"]["about"]["about"+this.dataManipSrvc.prefLanguage];
        //     }          
        //   }
        // }

        for (let j = 0; j < this.userTests.length; j++) {
          this.userTests[j]["testname"] = {};
          this.userTests[j]["abouttest"]["about"] = {}
          this.userTests[j]["abouttest"]["whocan"] = {}
          this.userTests[j]["testname"]["testname"] = this.tempUserTests[j]["testname"]["testname" + this.dataManipSrvc.prefLanguage];
          //this.userTests[j]["testname"]["testname"] = this.tempUserTests[j]["testname"]["testnamee"];
          // this.userTests[j]["testname"]["testnamel"] = this.tempUserTests[j]["testname"]["testname" + this.dataManipSrvc.prefLanguage];
          this.userTests[j]["abouttest"]["about"]["about"] = this.tempUserTests[j]["abouttest"]["about"]["about" + this.dataManipSrvc.prefLanguage];
          this.userTests[j]["abouttest"]["whocan"]["whocan"] = this.tempUserTests[j]["abouttest"]["whocan"]["whocan" + this.dataManipSrvc.prefLanguage];
          // this.userTests[j]["abouttest"]["about"]["about"] = this.tempUserTests[j]["abouttest"]["about"]["aboute"];
          //this.userTests[j]["abouttest"]["whocan"]["whocan"] = this.tempUserTests[j]["abouttest"]["whocan"]["whocane"];
        }

        if (this.completedTest == "Y") {
          let idx = this.userTests.findIndex(ele => ele["testid"] == this.completdTestId);
          if (idx >= 0) {
            let idx1 = this.userTests[idx]["testcompleted"].findIndex(ele => ele["usertestid"] == this.completedUserTestId);
            if (idx1 >= 0) {
              this.userTests[idx]["testcompleted"][idx1]["tc"] = true;
            }
          }
        }


        // console.log("MAIN JSON: ", JSON.stringify(this.userTests));
        this.getLanguage();
        // console.log(this.userTests,'this.userTests');

      }
    })
  }
  checkSubscribed() {
    for (let f = 0; f < this.userTests.length; f++) {

      if (this.userTests[f]["usergiventest"].length > 0) {
        let idx = this.userTests[f]["usergiventest"].findIndex(ele => ele["teststatus"] == "Y");
        if (idx >= 0) {
          this.userTests[f]["subscribed"] = "Y";
        }
        else {
          this.userTests[f]["subscribed"] = "N";
          // this.userTests[f]["completedcount"] = (this.userTests[f]["completedcount"] ? (this.userTests[f]["completedcount"]+1) : 0);
          this.userTests[f]["completedcount"] += 1;
        }
      }
    }
  }

  getLanguage() {
    if (this.dataManipSrvc.prefLanguage == "m") {
      this.prefLang = "Marathi";
    }
    else if (this.dataManipSrvc.prefLanguage == "e") {
      this.prefLang = "English";
    }
    else if (this.dataManipSrvc.prefLanguage == "h") {
      this.prefLang = "Hindi";
    }

  }

  viewTestDetails(i) {
    this.userTestIndex = i;
    this.viewtestDetailModal.show();
    this.showViewTestDetailsModal = true;

  }
  viewtestDetailModalClose() {
    this.showViewTestDetailsModal = false;
    this.viewtestDetailModal.hide();
    this.userTestIndex = -1;
  }
  walletDisplay() {

    if (this.flag == 0) {
      this.userID = this.dataManipSrvc.userId;
      let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/getWalletBalance";
      let param = {}
      this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
        if (successResp['errorCode'] == "000000") {
          if (successResp['Data'][0])
            this.balance = successResp['Data'][0]['walletbalance'];
    //      console.log(this.balance)

          this.defaultlayout.walletAmount = this.balance;//console.log(successResp['Data'][0]['walletbalance'])
        }
      });
    }
    if (this.flag == 1) {
      this.userID = this.dataManipSrvc.userId;
      let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/getWalletBalance";
      let param = {}
      this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
        if (successResp['errorCode'] == "000000") {
          this.balance = successResp['Data'][0]['walletbalance'];
    //      console.log(this.balance)
          this.subscribeToTest1();
        }
      });
    }

  }
  addWalletBalance(callbackFunction, ref = this) {
    this.insufficientBalModal.hide();
    this.defaultlayout.amountToaddinwallet = this.amounttopay;
    // this.defaultlayout.displaywalletpoppup("dashboard");
    // this.defaultlayout.displaywalletpoppup("directPay"); 
    this.defaultlayout.payWithPromise().then((res) => {
      // console.log("addWalletBalance",res);
      
      callbackFunction(ref);
    }).catch(err => {
      console.error("addWalletBalance", err);

    });

    // this.walletDisplay();

  }

  testType:string = '';

  startSubConfirm(i) {
    this.testType = this.userTests[i].testtype;
    this.dataManipSrvc.testType = this.userTests[i].testtype;
    this.dataManipSrvc.testId = this.userTests[i].testid;
    
    
    this.walletDisplay();
    this.testcharges = this.userTests[i]["testcharges"]
    this.testNumber = i;
    if (this.dataManipSrvc.testType == 'mindtendencytest') {
      setTimeout(() => {
        this.confirmTestModal.show();
      }, 20);
    }else{
      this.confirmSubModal.show();
    }
   

  }
  subscribeToTest1() {
    this.flag = 0;
    let i = this.testNumber;
    let testcharges = this.userTests[i]["testcharges"]
    // console.log(this.balance,testcharges);

    if (this.balance < testcharges) {
      this.amounttopay = testcharges - this.balance;
      //this.insufficientmsg="Please Add Money to Book a Test"
      this.insufficientmsg = "Top up wallet to Book this test of Rs. " + this.amounttopay + "/-"
      // this.insufficientBalModal.show();
      this.addWalletBalance(this.subscribeToTest, this)
      return;
    }
    let apiUrl = this.configSetting.getBaseUrl() + "user/subscribeToTest";
    let body = {
      "testid": this.userTests[i]["testid"],
      "age":this.dataManipSrvc.age
    }

    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        if (successResp['errorDescription'].trim() == 'SUCCESS') {
          this.userTests[i]["usergiventest"].push(
            {
              "testid": this.userTests[i]["testid"],
              "teststatus": successResp["Data"][0]["teststatus"],
              "usertestid": successResp["Data"][0]["usertestid"]
            }
          );
          this.flag = 0
          this.checkSubscribed();
          // this.userTests[i]["teststatus"] = successResp["Data"][0]["teststatus"];
          // this.userTests[i]["usertestid"] = successResp["Data"][0]["usertestid"];
          // this.userTests[i]["subscribed"] = "Y";
          // this.getUsersTests();
        } else {
          this.alertMsg = successResp['errorDescription'];
    //      console.log(successResp['errorDescription']);

          this.alertModal.show();
        }

      }
      this.walletDisplay();
    })


  }

  subscribeToTest(ref = this) {

    console.warn('subscribeToTest');
    // debugger;
    ref.flag = 1;
    ref.walletDisplay();
    ref.confirmSubModal.hide();


  }

  startTest(i) {
    this.testType = '';
    this.testIndex = i;
    let idx = this.userTests[i]["usergiventest"].findIndex(ele => ele["teststatus"] == "Y");
    if (idx >= 0) {
      this.dataManipSrvc.usertestid = this.userTests[i]["usergiventest"][idx]["usertestid"];
    }
    this.dataManipSrvc.testId = this.userTests[i]["testid"];
    this.dataManipSrvc.srno = this.userTests[i]['srno'];
    // this.dataManipSrvc.usertestid = this.userTests[i]["usertestid"];
    // this.dataManipSrvc.testName = this.userTests[i]["testname"]["testname"];
    setTimeout(() => {
      this.testLanguage = this.dataManipSrvc.prefLanguage;
      // this.dob = this.dataManipSrvc.dob;
    }, 90);

    this.dataManipSrvc.testType = this.userTests[i]["testtype"];
    if (this.dataManipSrvc.testType == 'trailtest') {
      this.isDOB = true;
    } else {
      this.isDOB = false;

    }

    if (this.userTests[i]["testimage"]) {
      this.dataManipSrvc.testImgSrcBase64 = this.userTests[i]["testimage"];
    }
    this.testLanguage = this.dataManipSrvc.prefLanguage;
    if (this.userTests[i]['usergiventest'].length) {
      this.testLanguage = this.userTests[i]['usergiventest'][0]['userselectedtestlanguage'];
      // console.log(this.testLanguage);

    }
    // console.log(this.userTests[i]);
    if (this.dob == "0000-00-00") {
      this.dob = "";
    }
    this.confirmTestModal.show()
  }
  startTestConfirm() {
    // console.log('in start test');
    
    // this.showLoader = true;
    // let apiUrl = this.configSetting.getBaseUrl() + "user/subscribeToTest";
    // let body = {

    // }
    // this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
    //   this.showLoader = false;
    //   if (successResp['errorCode'] == "000000") {

    //   }
    // })
    
    this.dataManipSrvc.testName = this.tempUserTests[this.testIndex]["testname"]["testname" + this.testLanguage];
    this.dataManipSrvc.testLangugae = this.testLanguage;
    this.dataManipSrvc.testInstructions = {};
    let tempInstructions = {};
    this.showLoader = true;
    let params = { "testid": this.dataManipSrvc.testId };
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/getTestInstructions";
    this.commonServices.getWithParams(apiUrl, params).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        
        this.dataManipSrvc.testInstructions = successResp["Data"]["instruction"];
        this.dataManipSrvc.requireddata = successResp["Data"]["requireddata"];
        if (Object.keys(this.dataManipSrvc.testInstructions).length > 0) {
          tempInstructions = JSON.parse(JSON.stringify(this.dataManipSrvc.testInstructions));
          this.dataManipSrvc.testInstructions["pretestinstr"] = [];
          for (let i = 0; i < tempInstructions["pretestinstr"].length; i++) {
            this.dataManipSrvc.testInstructions["pretestinstr"].push(
              {
                "srno": tempInstructions["pretestinstr"][i]["srno"],
                "instr": tempInstructions["pretestinstr"][i]["instr" + this.testLanguage]
              }
            )
          }
          if (this.dataManipSrvc.testInstructions["posttestinstr"].length > 0) {
            this.dataManipSrvc.testInstructions["posttestinstr"] = [];
            this.dataManipSrvc.testInstructions["posttestinstr"].push(
              {
                "instr": tempInstructions["posttestinstr"][0]["instr" + this.testLanguage]
              }
            )
          }
          else {
            this.dataManipSrvc.testInstructions['posttestinstr'].push({ "instr": "" });
          }

        }
        this.dataManipSrvc.testInstructions["instrheading"] = {};
        this.dataManipSrvc.testInstructions["instrheading"]["text"] = tempInstructions["instrheading"]["text" + this.testLanguage];

        this.router.navigateByUrl("/mytest");

      }
    })
    // if (this.userTests[this.testIndex]["instructiontext"].length > 0) {
    //   let testInstructions = this.userTests[this.testIndex]["instructiontext"];
    //   for (let i = 0; i < testInstructions.length; i++) {
    //     this.dataManipSrvc.testInstructions.push(
    //       {
    //         "srno": testInstructions[i]["srno"],
    //         "instr": testInstructions[i]["instr" + this.testLanguage]
    //       }
    //     )
    //   }
    // }
  }

  downloadTest(i, j) {
    // console.log("helo",i,j);
    this.showLoader = true;
    let params =
    {
      "userid": this.encryptService.encrypt(this.dataManipSrvc.userId + ""),
      "testid": this.encryptService.encrypt(this.userTests[i]["testid"] + ""),
      "usertestid": this.encryptService.encrypt(this.userTests[i]["testcompleted"][j]["usertestid"] + "")
    };

    // console.log(this.userTests[i]["testid"])
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/downloadResultPDF";
    this.commonServices.downloadReport(apiUrl, params).subscribe(successResp => {

      var blob = new Blob([successResp], { type: 'application/pdf' });
      var url = window.URL.createObjectURL(blob);
      let testDate = this.datePipe.transform(this.userTests[i]["testcompleted"][j]["testcompletedon"], "dd-MMM-yyyy_HH:MM");
//      console.log(this.userTests[i]["testcompleted"][j]["testcompletedon"]);

      let a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      //  a.download = this.userTests[i]["testname"]["testname"] + "_" + testDate;
      // a.download = this.tempUserTests[i]["testname"]["testname" + this.userTests[i]["testcompleted"][j]["userselectedtestlanguage"]] + "_" + testDate;
      a.download = this.tempUserTests[i]["testname"]["testname" + this.userTests[i]["testcompleted"][j]["userselectedtestlanguage"]] + "_" + this.userTests[i]["testcompleted"][j]["usertestid"] + "_" + testDate;

      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.showLoader = false;
    },
      err => {
        this.showLoader = false;
        alert("Problem while downloading the file.");

        console.error(err);
      }
    );
    this.confirmationModel.hide();
  }
  recommendTestModalEvt(i) {
    this.recommendResponseText = "";
    this.recommendResponseError = "";
    this.recommendComment = "";
    this.recommendEmail = "";
    this.toName = "";
    this.fromName = this.dataManipSrvc.userName;
    this.recommendIndex = i;
    this.showRecommendModal = true;
    this.recommendTestModal.show();
  }

  sendRecommendMail() {
    this.showLoader = true;
    this.loaderText = "Sending mail";
    let apiUrl = this.configSetting.getBaseUrl() + "dashtest/sendRecommendMail";
    let body = {
      "userid": this.dataManipSrvc.userId,
      "toname": this.toName,
      "fromname": this.fromName,
      "testid": this.userTests[this.recommendIndex]["testid"],
      "comments": this.recommendComment,
      "toemailid": this.recommendEmail
    }

    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        this.recommendResponseText = "Test successfully recommended.";
        this.recommendEmail = "";
        this.toName = "";
        this.fromName = "";
        this.recommendComment = "";
        this.recommendResponseError = "";
      }
      else {
        this.recommendResponseError = successResp['errorDescription']
        this.recommendResponseText = "";
        this.showLoader = false;
      }
    })
  }
  ClearMessages(eve){
    if (this.restrictCharacters(eve.key)) {
      eve.preventDefault();
    }
    
    this.recommendResponseText = "";
    this.recommendResponseError = "";
  }



  recommendTestModalClose() {
    this.recommendTestModal.hide();
    this.loaderText = "We are processing";
    this.showRecommendModal = false;
  }
  confirmationModalClose() {
    this.confirmationModel.hide();
  }
  showConfirmmodel(i, j) {
    this.downloadParams = { i, j }
    this.confirmationModel.show();
  }


  calculateAge() {
    console.log(this.dataManipSrvc.dob);

    let timeDiff = Math.abs(Date.now() - this.dataManipSrvc.dob?.getTime());
    this.dataManipSrvc.age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    // console.log(this.dataManipSrvc.age);
    // console.log(this.dataManipSrvc.dob);

    // this.dobStr = this.datePipe.transform(this.dataManipSrvc.dob,"yyyy-MM-dd")
  }
  checkDate() {
    // console.log(this.dob);
    let dob = this.datePipe.transform(this.dob, "yyyy-MM-dd");

    let apiUrl = this.configSetting.getBaseUrl() + "user/validateDOB";
    let params = { "userid": this.dataManipSrvc.userId, dob: dob };
    this.commonServices.getWithParams(apiUrl, params).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.isDOB = false;
        if (this.dataManipSrvc.dob == "0000-00-00") {
          this.dataManipSrvc.dob = "";
        }
        this.dataManipSrvc.dob = dob;
        this.dataManipSrvc.age = successResp['Data']['currentAge'];
      } else {
        this.dateErrorModal.show();
        this.isDOB = true;
      }
    })

  }

  checkDateForMindTendencyTest(){

    let dob = this.datePipe.transform(this.dob, "yyyy-MM-dd");

    let apiUrl = this.configSetting.getBaseUrl() + "user/validateDOBForMindTest";
    let params = { "userid": this.dataManipSrvc.userId, dob: dob, "testid": this.dataManipSrvc.testId, "srno":this.dataManipSrvc.usertestid};
    this.commonServices.getWithParams(apiUrl, params).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.isDOB = false;
        this.confirmTestModal.hide();
        if (this.dataManipSrvc.dob == "0000-00-00") {
          this.dataManipSrvc.dob = "";
        }
        this.dataManipSrvc.dob = dob;
        this.dataManipSrvc.age = successResp['Data']['currentAge'];
        setTimeout(() => {
          this.confirmSubModal.show();
        }, 20);
      } else {
        this.dateErrorMsg = successResp['errorDescription'];
        this.dateErrorModal.show();
        this.isDOB = true;
      }
    })

  }

  checkEmailIdEvt(page) {


    let params = {};
    if (page == 'R') {
      params = { 'emailid': this.recommendEmail }
    } else if (page == 'G') {
      params = { 'emailid': this.giftobj.email }
    }

    let apiUrl = this.configSetting.getBaseUrl() + "user/CheckEmailId";
    this.commonServices.getWithParams(apiUrl, params).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.errMsg = "";
      } else if (successResp['errorCode'] == 1012) {
        // this.errMsg = successResp['errorDescription'];
        if (page == 'G') {
          this.errMsg = '';
        } else {
          this.errMsg = "Enter valid Email Id";
        }
      } else {
        this.errMsg = "";
      }
    });
  }

  openTrailTestModal() {
    const ngbModalRef = this.ngbModal.open(TrailTestModalComponent, { windowClass: "trail-est-demo-modal", backdrop: 'static' });

    ngbModalRef.result.then((result) => {

      if (result && result?.status == "select") {

      }
    });
  }

  checkRecComment(val: string) {
    let inputBox;
    // console.log(val);
    
    if (val == 'giftTestInput') {
      inputBox = document.getElementById("giftTestInput");
    } else if (val == 'recommendInput') {
      inputBox = document.getElementById("recommendInput");
    }
    
    // let invalidChars = ["!", "@", "#", "$", "%", "^", "&", "*", "+", "-", "=", "<", ">", "/"]
    let invalidChars = ["<", ">"]

    inputBox.addEventListener("keydown", function (e) {
      // console.log(invalidChars.includes(e.key));
      
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });
  }

  restrictCharacters(str){
    const invalidChars = ["<", ">"];

    return invalidChars.includes(str);
  }
}
